import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect } from "vue"
import _imports_0 from '@/assets/icons/checkmark-circle-green.svg'
import _imports_1 from '@/assets/icons/checkmark-circle.svg'


const _hoisted_1 = { class: "w-3/4" }
const _hoisted_2 = {
  key: 1,
  class: "flex flex-row"
}
const _hoisted_3 = { class: "flex flex-col w-1/2 mr-2" }
const _hoisted_4 = { class: "flex flex-col bg-white rounded-2xl p-8" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row justify-between items-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "font-semibold text-lg" }, "Personal details")
], -1)
const _hoisted_6 = { class: "flex flex-col bg-white rounded-2xl p-8 mt-4" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "text-lg font-semibold" }, "Change password", -1)
const _hoisted_8 = { class: "flex flex-col mt-8" }
const _hoisted_9 = { class: "mt-4" }
const _hoisted_10 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_11 = {
  key: 1,
  class: "text-green-500"
}
const _hoisted_12 = { class: "flex flex-col mt-8" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "text-lg font-semibold" }, "Your password must have", -1)
const _hoisted_14 = { class: "flex flex-row items-center mt-4" }
const _hoisted_15 = {
  key: 0,
  src: _imports_0,
  class: "w-6 h-6"
}
const _hoisted_16 = {
  key: 1,
  src: _imports_1,
  class: "w-6 h-6"
}
const _hoisted_17 = { class: "flex flex-row items-center mt-4" }
const _hoisted_18 = {
  key: 0,
  src: _imports_0,
  class: "w-6 h-6"
}
const _hoisted_19 = {
  key: 1,
  src: _imports_1,
  class: "w-6 h-6"
}
const _hoisted_20 = { class: "flex flex-row items-center mt-4" }
const _hoisted_21 = {
  key: 0,
  src: _imports_0,
  class: "w-6 h-6"
}
const _hoisted_22 = {
  key: 1,
  src: _imports_1,
  class: "w-6 h-6"
}
const _hoisted_23 = { class: "flex flex-col w-1/2 ml-2" }
const _hoisted_24 = { class: "flex flex-col bg-white rounded-2xl p-8" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", { class: "text-lg font-semibold" }, "Default currency", -1)
const _hoisted_26 = ["value"]
const _hoisted_27 = { class: "flex flex-col bg-white rounded-2xl p-8 mt-4" }
const _hoisted_28 = { class: "flex flex-row justify-between items-start" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("span", { class: "text-lg font-semibold" }, "Organization name", -1)
const _hoisted_30 = {
  key: 1,
  class: "flex flex-col mt-4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_UserCard = _resolveComponent("UserCard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_Spinner, { key: 0 }))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createVNode(_component_UserCard, {
                firstName: _ctx.firstName,
                lastName: _ctx.lastName,
                position: _ctx.email,
                class: "mt-8"
              }, null, 8, ["firstName", "lastName", "position"])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.passwords.new) = $event)),
                  type: "password",
                  placeholder: "New password",
                  class: "border-0 rounded bg-gray-100 p-4 focus:bg-white focus:outline-none focus:ring-2 focus:ring-black"
                }, null, 512), [
                  [_vModelText, _ctx.passwords.new]
                ]),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.passwords.confirmation) = $event)),
                  type: "password",
                  placeholder: "Confirm password",
                  class: "border-0 rounded bg-gray-100 p-4 focus:bg-white focus:outline-none focus:ring-2 focus:ring-black mt-4"
                }, null, 512), [
                  [_vModelText, _ctx.passwords.confirmation]
                ]),
                _createElementVNode("div", _hoisted_9, [
                  (_ctx.changePasswordError)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_10, " Something went wrong, please try again. "))
                    : _createCommentVNode("", true),
                  (_ctx.changePasswordSuccess)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_11, " Password changed successfully! "))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("button", {
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.changeUserPassword && _ctx.changeUserPassword(...args))),
                  class: "space-x-3 btn-filled-sm flex flex-row items-center disabled:opacity-50 justify-center truncate text-base bg-primary rounded-full transition duration-150 ease-in disabled:cursor-not-allowed w-1/2 mt-4"
                }, " Update password ")
              ]),
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _createElementVNode("div", _hoisted_14, [
                  (_ctx.length)
                    ? (_openBlock(), _createElementBlock("img", _hoisted_15))
                    : (_openBlock(), _createElementBlock("img", _hoisted_16)),
                  _createElementVNode("span", {
                    class: _normalizeClass(["text-gray-400 ml-2", { 'text-green-500': _ctx.length }])
                  }, " A minimum of 10 characters ", 2)
                ]),
                _createElementVNode("div", _hoisted_17, [
                  (_ctx.casing)
                    ? (_openBlock(), _createElementBlock("img", _hoisted_18))
                    : (_openBlock(), _createElementBlock("img", _hoisted_19)),
                  _createElementVNode("span", {
                    class: _normalizeClass(["text-gray-400 ml-2", { 'text-green-500': _ctx.casing }])
                  }, " UPPERCASE and lowercase letters ", 2)
                ]),
                _createElementVNode("div", _hoisted_20, [
                  (_ctx.hasNumber)
                    ? (_openBlock(), _createElementBlock("img", _hoisted_21))
                    : (_openBlock(), _createElementBlock("img", _hoisted_22)),
                  _createElementVNode("span", {
                    class: _normalizeClass(["text-gray-400 ml-2", { 'text-green-500': _ctx.hasNumber }])
                  }, " A number ", 2)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _hoisted_25,
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedCurr) = $event)),
                class: "bg-background rounded p-4 mt-8"
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currencies, (curr, i) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: i,
                    value: curr.value
                  }, _toDisplayString(curr.name), 9, _hoisted_26))
                }), 128))
              ], 512), [
                [_vModelSelect, _ctx.selectedCurr]
              ])
            ]),
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, [
                _hoisted_29,
                (!_ctx.editCompany)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.editCompany = !_ctx.editCompany)),
                      class: "btn-text"
                    }, " Edit "))
                  : _createCommentVNode("", true)
              ]),
              (!_ctx.editCompany)
                ? (_openBlock(), _createBlock(_component_UserCard, {
                    key: 0,
                    firstName: _ctx.companyName,
                    class: "mt-8"
                  }, null, 8, ["firstName"]))
                : (_openBlock(), _createElementBlock("div", _hoisted_30, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.newCompany.name) = $event)),
                      type: "text",
                      placeholder: "Company name",
                      class: "inp-text"
                    }, null, 512), [
                      [_vModelText, _ctx.newCompany.name]
                    ]),
                    _createElementVNode("button", {
                      onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.editCompanyName && _ctx.editCompanyName(...args))),
                      class: "btn-filled-sm mt-4"
                    }, " Save changes ")
                  ]))
            ])
          ])
        ]))
  ]))
}